// removed by extract-text-webpack-plugin
module.exports = {"backgroundDark":"searchSurveyBanner-module_backgroundDark_2g__D","surveyText":"searchSurveyBanner-module_surveyText_JELCg","surveyDismissIcon":"searchSurveyBanner-module_surveyDismissIcon_FbkfA"};


//////////////////
// WEBPACK FOOTER
// ./client/components/banners/searchSurveyBanner.module.css
// module id = 509
// module chunks = 1 3